import type { IconProps } from '../types/IconProps.ts';
export const Navigation: IconProps = {
    name: 'Navigation',
    children: [
        `<g clip-path="url(#a)">`,
        `<path d="M21.96 2.02q.03-.01.02.02l-7.96 18.91q-.01.03-.04 0l-2.84-7.58a1 1 0 0 0-.5-.55l-7.6-3.8a.02.02 0 0 1 0-.04z" />`,
        `</g>`,
        `<defs>`,
        `<clipPath id="a">`,
        `<path d="M0 0h24v24H0z" />`,
        `</clipPath>`,
        `</defs>`,
    ]
};